import { featuredProducts } from '@/mocks/categories';

export default function FeaturedProducts() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Polecane produkty Kakobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Najpopularniejsze i najwyżej oceniane produkty według społeczności Kakobuy.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/80 bg-background-50">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/80 bg-background-100/70">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Produkt</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 hidden sm:table-cell">Kategoria</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700 hidden sm:table-cell">Popularność</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Ocena</th>
              </tr>
            </thead>
            <tbody>
              {featuredProducts.map((product, idx) => (
                <tr
                  key={idx}
                  className="border-b border-background-200/50 last:border-b-0 hover:bg-background-100/50 transition-colors duration-150"
                >
                  <td className="px-6 py-4">
                    <span className="text-sm font-medium text-foreground-800">{product.name}</span>
                  </td>
                  <td className="px-6 py-4 hidden sm:table-cell">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-800">
                      {product.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 hidden sm:table-cell">
                    <div className="flex items-center gap-2">
                      <div className="flex-1 max-w-[80px] h-1.5 bg-background-200 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-primary-500 rounded-full transition-all duration-500"
                          style={{ width: product.popularity }}
                        ></div>
                      </div>
                      <span className="text-xs font-medium text-foreground-600">{product.popularity}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i
                            className={`text-xs ${
                              i < product.rating
                                ? 'ri-star-fill text-amber-400'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          ></i>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}